export function formatNumber(number) {
    if (isValidNumber(number)) {
        return new Intl.NumberFormat('sv-SE', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Math.round(Number(number)));
    }
    return '-';
}
export function formatNumberWithDecimal(number, decimals = 1) {
    if (isValidNumber(number)) {
        return new Intl.NumberFormat('sv-SE', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: decimals,
        }).format(Number(number));
    }
    return '-';
}
export function formatForecastDate(dateString) {
    if (dateString === null || dateString === undefined) {
        return '-';
    }
    const [year, month] = dateString.toString().split('-');
    const date = new Date(Number(year), Number(month) - 1);
    if (isNaN(date.getTime())) {
        return '-';
    }
    const yearFormatter = new Intl.DateTimeFormat('sv-SE', { year: 'numeric' });
    const monthFormatter = new Intl.DateTimeFormat('sv-SE', { month: 'long' });
    return `${yearFormatter.format(date)} ${monthFormatter.format(date)}`;
}
export function isValidNumber(number) {
    return !(number === null ||
        number === undefined ||
        (typeof number !== 'number' && typeof number !== 'string') ||
        Number.isNaN(Number(number)));
}
export const fmtCurrency = (v) => new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(v);
export function completeAddress(streetName, buildingNumber) {
    if (!streetName || !buildingNumber)
        return null;
    return streetName + ' ' + buildingNumber;
}
